import { FC } from 'react';
import { FormProvider } from 'react-hook-form';
import styled from 'styled-components';
import { Row, Col } from 'react-bootstrap';
import { useRequests } from './useRequests';
import { RequestHeader } from './components/RequestHeader';
import { ComplementForms } from './components/ComplementForms';
import { Hr } from '../../../common/elements/Hr/Hr';
import { PopUp } from '../../../common/components/PopUp';
import { Colors } from '../../../assets';
import { Spacing } from '../../../assets/GlobalStyle/Variables';
import { useSidebarContext } from '../../../common/components/Sidebar/SidebarContext';
import PulseLoader from 'react-spinners/PulseLoader';

export const RequestsPage: FC = () => {
  const { methods, complementOptions, savedComplements, dirtyComplements, currentUserName, onSubmit, message, togglePopup, canPrint, onPrint, printing, canSend, handleSend, selectedComplement, isBatchLoading } = useRequests();
  const { isCollapsed } = useSidebarContext();

  return (
    <>
      {message && <PopUp message={message.message} toggle={togglePopup} type={message.type} />}

      <FormProvider {...methods}>
        <StyledForm onSubmit={methods.handleSubmit(onSubmit)}>
          <RequestHeader complementOptions={complementOptions} savedComplements={savedComplements} dirtyComplements={dirtyComplements} currentUserName={currentUserName} isLoading={isBatchLoading} />

          <Hr />

          <Row>
            <Col md={12}>
              <ComplementForms />
            </Col>
          </Row>

          <ActionBar $isCollapsed={isCollapsed}>
            <div />
            <ButtonGroup>
              {!['genetics', 'nrl_other'].includes(selectedComplement as string) && (
                <SecondaryButton type="button" onClick={onPrint} disabled={!canPrint}>{!printing ? 'Tisk' : <PulseLoader className="pulse-loader" size={6} color="#3c1149"/>}</SecondaryButton>
              )}

              {canSend && (
                <SecondaryButton type="button" onClick={handleSend}>Odeslat</SecondaryButton>
              )}
              <PrimaryButton type="submit">Uložit</PrimaryButton>
            </ButtonGroup>
          </ActionBar>
        </StyledForm>
      </FormProvider>
    </>
  );
};

const StyledForm = styled.form`
  padding-top: ${Spacing(4)};
  padding-bottom: 100px;
`;

const ActionBar = styled.div<{ $isCollapsed: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: auto;
  position: fixed;
  bottom: 0;
  left: ${(props) => (props.$isCollapsed ? '59px' : '178px')};
  right: 0;
  background-color: #ffffffec;
  padding: 1rem;
  border-top: 2px solid ${Colors.lightGrey};
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1;
  transition: left 0.3s ease;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: ${Spacing(2)};
`;

const SecondaryButton = styled.button`
  background-color: transparent;
  color: ${Colors.primary};
  border: 1px solid ${Colors.primary};
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  border-radius: 4px;

  &:hover:not(:disabled) {
    background-color: ${Colors.primary};
    color: #fff;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

const PrimaryButton = styled.button`
  background-color: ${Colors.primary};
  color: #fff;
  border: 1px solid ${Colors.primary};
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    background-color: ${Colors.secondary};
  }
`;
